import axios from 'axios'
import { ICrudDeleteAction, ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudSearchAction } from 'react-jhipster'

import { cleanEntity } from '../../../utils/entity-utils'
import { FAILURE, REQUEST, SUCCESS } from '../action-type.util'

import { defaultValue, IContinent } from '../../model/continent.model'

export const ACTION_TYPES = {
  SEARCH_CONTINENTS: 'continent/SEARCH_CONTINENTS',
  FETCH_CONTINENT_LIST: 'continent/FETCH_CONTINENT_LIST',
  FETCH_CONTINENT: 'continent/FETCH_CONTINENT',
  CREATE_CONTINENT: 'continent/CREATE_CONTINENT',
  UPDATE_CONTINENT: 'continent/UPDATE_CONTINENT',
  DELETE_CONTINENT: 'continent/DELETE_CONTINENT',
  RESET: 'continent/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IContinent>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

export type ContinentState = Readonly<typeof initialState>;

// Reducer

export default (state: ContinentState = initialState, action): ContinentState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.SEARCH_CONTINENTS):
    case REQUEST(ACTION_TYPES.FETCH_CONTINENT_LIST):
    case REQUEST(ACTION_TYPES.FETCH_CONTINENT):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_CONTINENT):
    case REQUEST(ACTION_TYPES.UPDATE_CONTINENT):
    case REQUEST(ACTION_TYPES.DELETE_CONTINENT):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.SEARCH_CONTINENTS):
    case FAILURE(ACTION_TYPES.FETCH_CONTINENT_LIST):
    case FAILURE(ACTION_TYPES.FETCH_CONTINENT):
    case FAILURE(ACTION_TYPES.CREATE_CONTINENT):
    case FAILURE(ACTION_TYPES.UPDATE_CONTINENT):
    case FAILURE(ACTION_TYPES.DELETE_CONTINENT):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.SEARCH_CONTINENTS):
    case SUCCESS(ACTION_TYPES.FETCH_CONTINENT_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10),
      };
    case SUCCESS(ACTION_TYPES.FETCH_CONTINENT):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_CONTINENT):
    case SUCCESS(ACTION_TYPES.UPDATE_CONTINENT):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_CONTINENT):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/continents';
const apiSearchUrl = 'api/_search/continents';

// Actions

export const getSearchEntities: ICrudSearchAction<IContinent> = (query, page, size, sort) => ({
  type: ACTION_TYPES.SEARCH_CONTINENTS,
  payload: axios.get<IContinent>(`${apiSearchUrl}?query=${query}${sort ? `&page=${page}&size=${size}&sort=${sort}` : ''}`),
});

export const getEntities: ICrudGetAllAction<IContinent> = (page, size, sort) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_CONTINENT_LIST,
    payload: axios.get<IContinent>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`),
  };
};

export const getEntity: ICrudGetAction<IContinent> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_CONTINENT,
    payload: axios.get<IContinent>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IContinent> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_CONTINENT,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IContinent> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_CONTINENT,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IContinent> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_CONTINENT,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
